import {
  InlineError$PunishAfterEditing,
  InlineError$PunishBeforeSubmitting,
  InlineError$PunishWhileEditing,
} from "@/modules/form-field/errors";
import { useField$Text } from "@/modules/form-field/hooks/useField$Text";

type Params = {
  initialNumEditions: number | undefined;
};

// TODO: Show a friendly error when updating the no. editions
// to be lower than the number of minted tokens.
function textToValue(text: string): number {
  text = text.replace(/[\s]/g, ""); // preprocessing: remove all spaces

  if (!text) {
    throw new InlineError$PunishBeforeSubmitting("This field is required");
  }

  if (text.startsWith("-")) {
    throw new InlineError$PunishWhileEditing("Negative value is not allowed");
  }

  if (/[^0-9]/.test(text)) {
    throw new InlineError$PunishWhileEditing(
      "Input contains invalid characters"
    );
  }

  const value = Number(text);

  if (value < 1) {
    throw new InlineError$PunishAfterEditing("Cannot be less than 1 edition");
  }

  if (value > 1e6) {
    throw new InlineError$PunishAfterEditing(
      "Cannot be more than 1000000 editions"
    );
  }

  return value;
}

function valueToText(value: number): string {
  return value.toString();
}

export const useFieldNumEditions = useField$Text.withConfig<number, Params>({
  getInitialText: ({ initialNumEditions }) =>
    initialNumEditions != null ? valueToText(initialNumEditions) : "",
  valueToText,
  textToValue,
});
